export default (function (obj, key) { return obj.hasOwnProperty(key); });
//# sourceMappingURL=has.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/has.js
// module id = 147
// module chunks = 3